"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("react-bootstrap/lib");

var _uncontrollable = require("uncontrollable");

var _expressionAtlasDisclaimers = _interopRequireDefault(require("@ebi-gene-expression-group/expression-atlas-disclaimers"));

var _Download = _interopRequireDefault(require("./Download.js"));

var _urijs = _interopRequireDefault(require("urijs"));

var _chartDataPropTypes = require("../../../manipulate/chartDataPropTypes.js");

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var buttonUnsetStyles = {
  textTransform: "unset",
  letterSpacing: "unset",
  height: "unset"
};

var _DownloadWithModal = function _DownloadWithModal(_ref) {
  var showModal = _ref.showModal,
      onChangeShowModal = _ref.onChangeShowModal,
      Disclaimer = _ref.Disclaimer,
      downloadOptions = _ref.downloadOptions;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    bsSize: "small",
    onClick: onChangeShowModal.bind(_this, true),
    title: "Download",
    style: buttonUnsetStyles
  }, /*#__PURE__*/_react["default"].createElement(_lib.Glyphicon, {
    glyph: "download"
  }), " Download"), /*#__PURE__*/_react["default"].createElement(_lib.Modal, {
    show: showModal,
    onHide: onChangeShowModal.bind(_this, false)
  }, /*#__PURE__*/_react["default"].createElement(_lib.Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_lib.Modal.Title, null, "Data Reuse Licence Agreement")), /*#__PURE__*/_react["default"].createElement(_lib.Modal.Body, null, /*#__PURE__*/_react["default"].createElement(Disclaimer, null)), /*#__PURE__*/_react["default"].createElement(_lib.Modal.Footer, null, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    onClick: onChangeShowModal.bind(_this, false)
  }, "Close"), downloadOptions.map(function (o) {
    return /*#__PURE__*/_react["default"].createElement(_lib.Button, {
      key: o.description,
      bsStyle: "primary",
      onClick: function onClick() {
        o.onClick();
        onChangeShowModal(false);
      }
    }, "Download: ".concat(o.description));
  }))));
};

var DownloadWithModal = (0, _uncontrollable.uncontrollable)(_DownloadWithModal, {
  showModal: "onChangeShowModal"
});
DownloadWithModal.defaultProps = {
  defaultShowModal: false
};

var SplitDownloadButton = function SplitDownloadButton(_ref2) {
  var downloadOptions = _ref2.downloadOptions;
  return /*#__PURE__*/_react["default"].createElement(_lib.SplitButton, {
    id: "download-button",
    style: buttonUnsetStyles,
    bsSize: "small",
    onClick: downloadOptions[0].onClick,
    title: "Download"
  }, downloadOptions.map(function (o, ix) {
    return /*#__PURE__*/_react["default"].createElement(_lib.MenuItem, {
      key: ix,
      eventKey: ix,
      id: o.description,
      onClick: o.onClick,
      style: buttonUnsetStyles
    }, /*#__PURE__*/_react["default"].createElement(_lib.Glyphicon, {
      glyph: "download-alt"
    }), " ", o.description);
  }));
};

var DownloadButton = function DownloadButton(_ref3) {
  var currentlyShownContent = _ref3.currentlyShownContent,
      fullDatasetUrl = _ref3.fullDatasetUrl,
      disclaimer = _ref3.disclaimer;
  var downloadOptions = [].concat(fullDatasetUrl ? [{
    onClick: function onClick() {
      return window.open(new _urijs["default"](fullDatasetUrl).setSearch({
        cutoff: "0.0"
      }).removeSearch("heatmapMatrixSize").toString(), "Download");
    },
    description: "All data"
  }] : [], [{
    onClick: function onClick() {
      return (0, _Download["default"])(_objectSpread(_objectSpread({}, currentlyShownContent), {}, {
        isSingleExperiment: Boolean(fullDatasetUrl)
      }));
    },
    description: "Table content"
  }]);
  return _expressionAtlasDisclaimers["default"][disclaimer] ? /*#__PURE__*/_react["default"].createElement(DownloadWithModal, {
    Disclaimer: _expressionAtlasDisclaimers["default"][disclaimer],
    downloadOptions: downloadOptions
  }) : /*#__PURE__*/_react["default"].createElement(SplitDownloadButton, {
    downloadOptions: downloadOptions
  });
};

DownloadButton.propTypes = {
  currentlyShownContent: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    descriptionLines: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
    heatmapData: _chartDataPropTypes.heatmapDataPropTypes
  }).isRequired,
  fullDatasetUrl: _propTypes["default"].string.isRequired,
  disclaimer: _propTypes["default"].string.isRequired
};
var _default = DownloadButton;
exports["default"] = _default;